import { render, staticRenderFns } from "./LastRoom.vue?vue&type=template&id=95f12f04&"
import script from "./LastRoom.vue?vue&type=script&lang=ts&"
export * from "./LastRoom.vue?vue&type=script&lang=ts&"
import style0 from "./LastRoom.vue?vue&type=style&index=0&id=95f12f04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports